import React, {Component} from "react";
import {connect} from "react-redux";

export const shouldAuthenticate = (requirement, typeUser, roles) => {
    if (!typeUser || !roles || typeUser === 'operator' || requirement === '') return true;
    if (!requirement) {
        console.log("Role requirement is undefined.");
        return false;
    }
    for (let role of requirement) {
        if (roles.includes(role)) return true;
    }
    return false;
}


const protect = requirement => WrappedComponent => {

    const mapStateToProps = (state) => {
        return {
            roles: state.authReducer.userClaims.roles,
            typeUser: state.authReducer.userClaims.typeUser
        };
    };

    class withAuth extends Component {
        render() {
            const {typeUser, roles, dispatch, ...other} = this.props
            return (
                shouldAuthenticate(requirement, typeUser, roles) ?
                    <WrappedComponent {...other} /> :
                    null
            );
        }
    }

    return connect(mapStateToProps)(withAuth);
}


export default protect;
